<template>
  <!-- Speedmap position -->
  <div v-if="!runner.scratched && runner.speedmapPosition" style="float: left" class="primaryColSM" :class="['position-' + runner.speedmapPosition, `scale${clientVisibility==='open'?'In':'Out'}`]">
    <v-btn
      height="20"
      width="20"
      fab
      x-small
      color="white"
      class="caption font-weight-bold"
      style="margin-left:2px; float: left; margin-top: 1px"
    >{{runner.barrier}}</v-btn>
    <img
      class="mr-n7 mt-n1"
      style="float: right; padding-left: 10px;"
      :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
      alt="jockey silks"
      height="30"
    />
    <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
    <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
  </div>
  <!-- No speedmap position -->
  <div v-else-if="!runner.scratched && !runner.speedmapPosition" style="float: left;" class="noSpeedMapPos primaryColSM" :class="[`scale${clientVisibility==='open'?'In':'Out'}`]" >
    <v-btn
      height="20"
      width="20"
      fab
      x-small
      color="white"
      class="caption font-weight-bold"
      style="margin-left:2px; float: left; margin-top: 1px"
    >{{runner.barrier}}</v-btn>
    <img
      class="mr-n7 mt-n1"
      style="float: right; padding-left: 10px;"
      :src="$silksUrl+'/'+gbsID+'_'+race.number+'_'+runner.tabNo+'_64x64.png'"
      alt="jockey silks"
      height="30"
    />
    <b class="trackToRightRunner" v-if="runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}}</b>
    <b class="trackToRightRunner" v-else-if="!runner.runnerStatistics.career.all.numberOfRuns">{{runner.tabNo}}. {{runner.name}} (F/S)</b>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PlatformSpeedMap',
  props: {
    runner: Object,
    race: Object
  },
  computed: {
    ...mapState(['gbsID', 'clientVisibility'])
  },
  methods: {
    stateToRight (state) {
      switch (state) {
        case 'QLD':
          return true
        case 'NSW':
          return true
        case 'ACT':
          return true
      }
    },
    stateToLeft (state) {
      switch (state) {
        case 'VIC':
          return true
        case 'SA':
          return true
        case 'WA':
          return true
        case 'NT':
          return true
        case 'TAS':
          return true
      }
    }
  }
}
</script>

<style scoped>

@keyframes expand {
  from {transform: scaleX(0);}
  to {transform: scaleX(1);}
}

.scaleIn {
  transform-origin: -100% 50%;
  animation-name: expand;
  animation-duration: 1s;
}

.scaleOut {
  transform-origin: -100% 50%;
  animation-name: "";
  transition: all 1s ease-in-out;
  transform: scaleX(0);
}
.trackToRightRunner {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 60%;
  white-space: nowrap;
  float: right;
  font-size: 12px;
}
.trackToLeftRunner {
  text-overflow: ellipsis;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  float: left;
  font-size: 12px;
}
.noSpeedMapPos {
  width: 35%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-REAR {
  width: 25%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-MID {
  width: 35%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-HANDY\/MID {
  width: 50%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-HANDY {
  width: 65%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-LEAD\/HANDY {
  width: 80%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
.position-LEAD {
  width: 90%;
  height: 22px;
  line-height: 22px;
  border-radius: 10px 10px 10px 10px;
}
</style>
